import { ref } from 'vue';
import { defineStore, storeToRefs } from 'pinia';
import type { ManagerUser } from '@/objects/generated';

export const useUserStore = defineStore('user', () => {
    const user = ref<ManagerUser | null>(null);
    return { user };
});

/**
 * Return a reactive reference to the user store.
 * @returns
 */
export const useUserStoreRef = () => storeToRefs(useUserStore());
